import { initializeApp } from "firebase/app";
import "firebase/auth";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBStkcVwKiLk5z70wIPX8fbXcyw1s6xyCA",
  authDomain: "benoma-website.firebaseapp.com",
  projectId: "benoma-website",
  storageBucket: "benoma-website.firebasestorage.app",
  messagingSenderId: "73327625523",
  appId: "1:73327625523:web:ac66bed2a8245bcd1e6a46",
  measurementId: "G-HWX807NK6S",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// init services
const projectFirestore = getFirestore(app);
const projectAuth = getAuth(app);
const projectStorage = getStorage(app);

export { projectFirestore, projectAuth, projectStorage };
